export interface RaidProgressEntry {
  name: string;
  difficulty: 'Mythic' | 'Heroic';
  progress: string;
  status: string;
  date?: string;
}

export const RAID_PROGRESS_ENTRIES: RaidProgressEntry[] = [
  { name: 'Dreamrift', difficulty: 'Mythic', progress: '1/1', status: 'Cutting Edge', date: 'Current Tier' },
  { name: "March on Quel'Danas", difficulty: 'Mythic', progress: '0/2', status: 'Progression', date: 'Current Tier' },
  { name: 'Dreamrift', difficulty: 'Heroic', progress: '1/1', status: 'Cleared', date: 'Current Tier' },
  { name: 'Voidspire', difficulty: 'Heroic', progress: '6/6', status: 'Cleared', date: 'Current Tier' },
  { name: "March on Quel'Danas", difficulty: 'Heroic', progress: '2/2', status: 'Cleared', date: 'Current Tier' },
  { name: 'Manaforge Omega', difficulty: 'Heroic', progress: '8/8', status: 'Season 3', date: 'The War Within' },
  { name: 'Liberation of Undermine', difficulty: 'Mythic', progress: '3/8', status: 'Season 2', date: 'The War Within' },
  { name: 'Liberation of Undermine', difficulty: 'Heroic', progress: '8/8', status: 'Season 2', date: 'The War Within' },
  { name: 'Nerub-Ar Palace', difficulty: 'Mythic', progress: '4/8', status: 'Season 1', date: 'The War Within' },
  { name: 'Nerub-Ar Palace', difficulty: 'Heroic', progress: '8/8', status: 'Season 1', date: 'The War Within' },
  { name: "Amirdrassil, The Dream's Hope", difficulty: 'Mythic', progress: '6/9', status: 'Season 3', date: 'Dragonflight' },
  { name: "Amirdrassil, The Dream's Hope", difficulty: 'Heroic', progress: '9/9', status: 'Cleared' },
];

export function sumRaidProgress(entries: RaidProgressEntry[]): string {
  const totals = entries.reduce(
    (acc, entry) => {
      const [killedRaw, totalRaw] = entry.progress.split('/');
      const killed = Number(killedRaw);
      const total = Number(totalRaw);
      if (!Number.isNaN(killed) && !Number.isNaN(total)) {
        acc.killed += killed;
        acc.total += total;
      }
      return acc;
    },
    { killed: 0, total: 0 }
  );
  return `${totals.killed}/${totals.total}`;
}

export function getCurrentTierProgress(difficulty: RaidProgressEntry['difficulty']): string {
  const currentTier = RAID_PROGRESS_ENTRIES.filter(
    (r) => r.date === 'Current Tier' && r.difficulty === difficulty
  );
  return sumRaidProgress(currentTier);
}
